import { ChainID } from '@ankr.com/chains-list';
import { useEffect, useMemo, useState } from 'react';

import { EndpointGroup } from 'modules/endpoints/types';
import { isBeacon } from 'modules/chains/utils/isBeacon';
import { isOpnode } from 'modules/chains/utils/isOpnode';

import { Consensus } from '../types';

const getConensus = (
  beaconGroup?: EndpointGroup,
  opnodeGroup?: EndpointGroup,
): Consensus | undefined => {
  if (beaconGroup) {
    return 'beacon';
  }

  if (opnodeGroup) {
    return 'opnode';
  }

  return undefined;
};

export interface ChainProtocolParams {
  group: EndpointGroup;
  subchainID?: ChainID;
}

export const useConsensus = ({ group, subchainID }: ChainProtocolParams) => {
  const [isConsensusEnabled, setIsConsensusEnabled] = useState(
    isBeacon(subchainID) || isOpnode(subchainID),
  );

  const beaconGroup = group.beacons?.[0];
  const opnodeGroup = group.opnodes?.[0];
  const consensusGroup = beaconGroup || opnodeGroup;
  const consensus = useMemo(
    () => getConensus(beaconGroup, opnodeGroup),
    [beaconGroup, opnodeGroup],
  );

  useEffect(() => {
    if (isConsensusEnabled && !consensusGroup) {
      setIsConsensusEnabled(false);
    }
  }, [consensusGroup, isConsensusEnabled]);

  return {
    consensus,
    consensusGroup,
    isConsensusEnabled,
    setIsConsensusEnabled,
  };
};
